import { RootState, useTypedSelector } from 'lib/centralStore';
import { selectCavalliNonVincenti, selectCavalliVincenti, selectHeaderList } from 'features/ippica/selectors';

import { IppicaScommesseTableRowResult } from '../ippicaScommesseTableRow/ippicaScommesseTableRowResult';
import { IppicaScommesseTableTitles } from '../ippicaScommesseTableTitles';
import { Wrapper } from 'components/wrapper';
import { breakpoint } from 'utility/constant';
import styles from './IppicaRisultatiRenderer.module.scss';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';

export const IppicaRisultatiRenderer = () => {
  const cavalliVincentiKeyList = useTypedSelector(selectCavalliVincenti);
  const cavalliNonVincentiKeyList = useTypedSelector(selectCavalliNonVincenti);

  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.lg }]);

  const headerListSelected = useTypedSelector(selectHeaderList());
  const isOpen = useTypedSelector(selectIsOpenCarrello);

  return (
    <Wrapper
      bgColorTransparent
      noPaddingTop
      noPaddingLeft
      noPaddingRight={isOpen || isMobile}
      classNameWrapper={`${styles.noBorderRadiusTop} ${isOpen ? styles.noMarginRigth : ''}`}
      className={`ippicaBackgroundNoContent`}
    >
      {!!cavalliVincentiKeyList?.length && (
        <>
          <h3 className={styles.title}>Prime Posizioni</h3>
          {!isMobile && <IppicaScommesseTableTitles titles={headerListSelected} />}
        </>
      )}
      {!!cavalliVincentiKeyList?.length &&
        cavalliVincentiKeyList.map((keyCavallo: string) => {
          return <IppicaScommesseTableRowResult key={keyCavallo} keyCavallo={keyCavallo} />;
        })}
      {!!cavalliNonVincentiKeyList?.length && <h3 className={styles.title}>Posizioni</h3>}
      {!isMobile && !!cavalliNonVincentiKeyList?.length && <IppicaScommesseTableTitles titles={headerListSelected} />}
      {!!cavalliNonVincentiKeyList?.length &&
        cavalliNonVincentiKeyList.map((keyCavallo: string) => {
          return <IppicaScommesseTableRowResult key={keyCavallo} keyCavallo={keyCavallo} />;
        })}
    </Wrapper>
  );
};
